<template>
  <div class="card">
    <header class="card-header">
      <a class="card-header-icon" aria-label="os">
        <agent-status
          :online="node.isActive"
          :os="node.os"
          :name="node.name"
          width="32px"
          height="32px"
        />
      </a>
      <p class="card-header-title" :class="{ removed: node.removed }">
        {{ node.remark || node.name }}
      </p>
      <a class="card-header-icon" aria-label="state" fa-tooltip-pos="left">
        <span
          class="state-circle"
          :class="[state]"
          v-bind:title="stateText"
        ></span>
      </a>
    </header>
    <!--BEGIN dialog1-->
    <div
      class="js_dialog"
      role="dialog"
      aria-hidden="true"
      aria-modal="true"
      aria-labelledby="js_title1"
      id="iosDialog1"
      style="display: none"
    >
      <div class="weui-mask"></div>
      <div class="weui-dialog">
        <div class="weui-dialog__hd">
          <strong class="weui-dialog__title" id="js_title1">弹窗标题</strong>
        </div>
        <div class="weui-dialog__bd">
          弹窗内容，告知当前状态、信息和解决方法，描述文字尽量控制在三行内
        </div>
        <div class="weui-dialog__ft">
          <a
            role="button"
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_default"
            >辅助操作</a
          >
          <a
            role="button"
            href="javascript:"
            class="weui-dialog__btn weui-dialog__btn_primary"
            >主操作</a
          >
        </div>
      </div>
    </div>
    <!--END dialog1-->
    <div class="card-content">
      <div class="content">
        <div class="columns is-mobile">
          <div class="column is-one-third">
            <label>{{ $t("lanip") }}</label>
            <p>{{ node.lanip }}</p>
          </div>
          <div class="column">
            <label>{{ $t("os") }}</label>
            <p>{{ node.os }}</p>
          </div>
        </div>
        <div class="columns is-mobile">
          <div class="column is-one-third">
            <label>{{ $t("wanip") }}</label>
            <p>{{ node.ip }}</p>
          </div>
          <div class="column">
            <label>{{ $t("version") }}</label>
            <p>{{ node.version }}</p>
          </div>
          <div class="column">
            <a
              v-if="!node.isUpdate"
              :class="{ disabled: node.isUpdate }"
              @click="handleEmit('update')"
              style="position: relative; color: white; stroke: #757c8a"
              :title="node.latestVer"
            >
              <feather-upload-cloud class="icon"></feather-upload-cloud>
              {{ $t("update") }}
              <span
                v-if="!node.isUpdate"
                class="weui-badge weui-badge_dot"
                style="position: relative; top: -8px; right: -1px"
              ></span>
            </a>
          </div>
        </div>
        <div v-if="node.ipv6 && node.ipv6.length > 5" class="columns is-mobile">
          <div class="column">
            <label>IPv6</label>
            <p>{{ node.ipv6 }}</p>
          </div>
        </div>
      </div>
    </div>
    <footer class="card-footer">
      <a
        class="card-footer-item"
        @click="handleEmit('p2papp')"
        style="position: relative"
      >
        <feather-list class="icon"></feather-list>
        {{ $t("p2papp") }}
        <span
          v-if="showAppBadge"
          class="weui-badge weui-badge_dot"
          style="position: relative; top: -8px; right: -1px"
        ></span>
      </a>
      <a class="card-footer-item" @click="handleEmit('edit')">
        <feather-edit class="icon"></feather-edit>
        {{ $t("edit") }}
      </a>
      <a class="card-footer-item" @click="handleEmit('delete')">
        <feather-trash class="icon"></feather-trash>
        {{ $t("delete") }}
      </a>
      <a class="card-footer-item" @click="handleEmit('restart')">
        <feather-power class="icon"></feather-power>
        {{ $t("reboot") }}
      </a>
    </footer>
  </div>
</template>

<script>
import AgentStatus from "../other/AgentStatus.vue"
import axios from "axios"
import weui from "weui.js"
export default {
  name: "deviceCard",

  components: {
    AgentStatus,
  },

  props: {
    node: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {}
  },

  computed: {
    stateText() {
      return this.node.isActive
        ? this.$t("online")
        : this.$t("offline") +
            " " +
            this.$t("activeTime") +
            this.node.activetime
    },
    state() {
      return this.node.isActive ? "on" : "off"
    },
    showAppBadge() {
      return this.$store.state.nodes.length > 2 ? false : true
    },
    showUpdateBadge() {
      return this.$store.state.nodes.length > 2 ? false : true
    },
  },

  beforeMount() {},

  methods: {
    async manageApps() {
      this.$router.push("/app/" + this.node.id)
    },
    async handleEmit(action) {
      let _this = this
      switch (action) {
        case "p2papp":
          this.$router.push("/app/" + encodeURIComponent(this.node.name))
          break
        case "update":
          window.debugLog(this.node.name, " update")
          if (this.node.os == "Android") {
            weui.alert(this.$t("nodes.androidManualUpgrade"), {
              buttons: [
                {
                  label: this.$t("ok"),
                },
              ],
            })
            return
          }
          weui.dialog({
            title: "",
            content:
              this.$t("confirm") +
              "" +
              this.$t("update") +
              " " +
              this.node.name +
              "?",
            className: "custom-classname",
            buttons: [
              {
                label: this.$t("cancel"),
                type: "default",
                onClick: function () {},
              },
              {
                label: this.$t("ok"),
                type: "primary",
                onClick: function () {
                  window.debugLog(_this.node.name, " update")
                  axios
                    .get(
                      _this.$ServerHost +
                        "/api/v1/device/" +
                        encodeURIComponent(_this.node.name) +
                        "/update"
                    )
                    .then((response) => {
                      if (response.status == 200 && response.data.error == 0) {
                        weui.alert(
                          _this.node.name +
                            " " +
                            _this.$t("nodes.pushUpgradeOK"),
                          {
                            buttons: [
                              {
                                label: _this.$t("ok"),
                              },
                            ],
                          }
                        )
                      } else {
                        weui.alert(
                          _this.node.name +
                            " " +
                            _this.$t("nodes.pushUpgradeError"),
                          {
                            buttons: [
                              {
                                label: _this.$t("ok"),
                              },
                            ],
                          }
                        )
                      }
                    })
                    .catch(function () {
                      weui.alert(
                        _this.node.name +
                          " " +
                          _this.$t("nodes.pushUpgradeError"),
                        {
                          buttons: [
                            {
                              label: _this.$t("ok"),
                            },
                          ],
                        }
                      )
                    })
                },
              },
            ],
          })
          break
        case "delete":
          weui.dialog({
            title: "",
            content:
              this.$t("confirm") +
              "" +
              this.$t("delete") +
              " " +
              this.node.name +
              "?",
            className: "custom-classname",
            buttons: [
              {
                label: this.$t("cancel"),
                type: "default",
                onClick: function () {},
              },
              {
                label: this.$t("ok"),
                type: "primary",
                onClick: function () {
                  window.debugLog(_this.node.name, " delete")
                  axios
                    .get(
                      _this.$ServerHost +
                        "/api/v1/device/" +
                        encodeURIComponent(_this.node.name) +
                        "/delete"
                    )
                    .then((response) => {
                      if (response.status == 200 && response.data.error == 0) {
                        let newNodes = _this.$store.state.nodes.filter(
                          (node) => node.name != _this.node.name
                        )
                        _this.$store.commit("setNodes", newNodes)
                        weui.alert(
                          _this.node.name +
                            _this.$t("deleteOK") +
                            " <br><br>" +
                            '<a href="' +
                            _this.$t("uninstallURL") +
                            '" target="_blank">' +
                            _this.$t("uninstallText") +
                            "</a>",
                          {
                            buttons: [
                              {
                                label: _this.$t("ok"),
                              },
                            ],
                          }
                        )
                      } else {
                        weui.alert(this.node.name + this.$t("deleteError"), {
                          buttons: [
                            {
                              label: this.$t("ok"),
                            },
                          ],
                        })
                      }
                    })
                    .catch(function () {
                      weui.alert(this.node.name + this.$t("deleteError"), {
                        buttons: [
                          {
                            label: this.$t("ok"),
                          },
                        ],
                      })
                    })
                },
              },
            ],
          })

          break
        case "edit":
          window.debugLog(this.node.name, " edit")
          this.$router.push({
            path: "/nodeedit/" + encodeURIComponent(this.node.name),
            query: this.node,
          })
          break
        case "restart":
          weui.dialog({
            title: "",
            content:
              _this.$t("confirm") +
              "" +
              _this.$t("reboot") +
              " " +
              _this.node.name +
              "?",
            className: "custom-classname",
            buttons: [
              {
                label: _this.$t("cancel"),
                type: "default",
                onClick: function () {},
              },
              {
                label: _this.$t("ok"),
                type: "primary",
                onClick: function () {
                  window.debugLog(_this.node.name, " restart")
                  axios
                    .get(
                      _this.$ServerHost +
                        "/api/v1/device/" +
                        encodeURIComponent(_this.node.name) +
                        "/restart"
                    )
                    .then((response) => {
                      if (response.status == 200 && response.data.error == 0) {
                        weui.alert(_this.$t("nodes.operationOK"), {
                          buttons: [
                            {
                              label: _this.$t("ok"),
                            },
                          ],
                        })
                      } else {
                        weui.alert(_this.$t("nodes.operationError"), {
                          buttons: [
                            {
                              label: _this.$t("ok"),
                            },
                          ],
                        })
                      }
                    })
                    .catch(function () {
                      weui.alert(_this.$t("nodes.operationError"), {
                        buttons: [
                          {
                            label: _this.$t("ok"),
                          },
                        ],
                      })
                    })
                },
              },
            ],
          })

          break
        default:
          return
      }
    },
  },
}
</script>

<style lang="scss">
@import "../../assets/css/card.scss";
</style>

